// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2021-01-20 11:30:52 +0100 (Wed, 20 Jan 2021) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 116239 $
//  Purpose   : test ui-props (parts feature) and usePersistent hook
// =============================================================================

// ---Third-party imports
import React from 'react'
import {Message} from 'semantic-ui-react'

// ---Framework imports
import {Part, funcPart} from 'uix/parts'
import {Actions} from 'uix/registries'
import log from 'uix/logging'
import {usePersistent, usePersistentShallow} from 'uix/hooks'

// ---Globals

export class TestUIProps extends Part {
  static uiDefaults = {
    __version__: 6,
    majorValue: 'TestUIProps',
    minorValue: 'empty',
  }
  modify = () => {
    this.props.setUI({majorValue: Math.random()})
  }

  _render() {
    let {type, ui, setUI} = this.props
    return <UiPropsMsg type={type} onClick={this.modify} ui={ui} />
  }
}

const UiPropsMsg = ({type, onClick, ui}) => {
  return (
    <Message>
      {'Part '}
      <b onClick={onClick} style={{cursor: 'pointer'}}>
        {type}
      </b>
      {' with '}
      <span className="value">{JSON.stringify(ui)}</span>
    </Message>
  )
}

export class TestUIPropsDerived1 extends TestUIProps {
  static uiDefaults = {
    __version__: 3,
    minorValue: 'TestUIPropsDerived1',
  }
  modify = () => {
    let {setUI} = this.props
    setUI({minorValue: Math.random()})
  }
}

export class TestUIPropsDerived2 extends TestUIProps {}

export class TestUIPropsDerived3 extends TestUIProps {
  static uiDefaults = {
    __version__: 3,
    majorValue: 'TestUIPropsDerived3',
  }
}

export class TestUIPropsDerived4 extends TestUIProps {
  static uiDefaults = {
    __name__: 'SHARED_NAME',
    sharedValue: 1,
  }
  modify = () => {
    let {setUI} = this.props
    setUI({sharedValue: `Derived4 - ${Math.random()}`})
  }
}

export class TestUIPropsDerived5 extends TestUIProps {
  static uiDefaults = {
    __name__: 'SHARED_NAME',
    sharedValue: 2,
  }

  modify = () => {
    let {setUI} = this.props
    setUI({sharedValue: `Derived5 - ${Math.random()}`})
  }
}

export const TestUIPropsFunctional = funcPart(
  {uiDefaults: {majorValue: 'value0', __version__: 1}},
  ({type, ui, setUI}) => {
    return <UiPropsMsg type={type} ui={ui} onClick={() => setUI({majorValue: Math.random()})} />
  }
)

export const TestUIPropsHooks = () => {
  let [ui, setUI] = usePersistentShallow('hooktest', {majorValue: 'value1', stable: 1}, 1)
  return (
    <UiPropsMsg
      type="TestUIPropsHooksShallow"
      ui={ui}
      onClick={() => setUI({majorValue: Math.random()})}
    />
  )
}

export const TestUIPropsHooksRaw = () => {
  let [value, setValue] = usePersistent('hooktest_raw', 'ABC', 1)
  return (
    <UiPropsMsg type="TestUIPropsHooksRaw" ui={value} onClick={() => setValue(Math.random())} />
  )
}
